// extracted by mini-css-extract-plugin
module.exports = {"changeIconContainer":"styles_changeIconContainer__3Sf1x"};